import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdCropImageAssetResult = objectOf({
  id: string,
  created_at: number,
  name: string,
  size: number,
  territory_ids: arrayOf(nullOrUndefined),
  app_group_id: string,
  ext: string,
  created_by: string,
  last_edited_by: string,
  url: string,
  type: string,
  known_width: number,
  known_height: number,
  ratio: number,
  path: string,
  tag_ids: arrayOf(nullOrUndefined),
});
